import { AIBadgeScore, Avatar, FLagWithText, Flex, Icon, Skeleton, Text } from "components/common"
import { TitleDescription } from "components/custom"
import { configs } from "configs"
import { memo } from "react"
import { capitalizeFirstLetter, joinBytItems, localisedValue } from "utils"

const ChatHeader = memo(({ client, isLoading = false, onInsightsClick, chatHeaderInfo }) => {
  return (
    <Flex justify={"space-between"} align="center" className={"pb-20 pi-24"}>
      {isLoading ? (
        <Flex gap="12px" align="flex-start">
          <Skeleton type="avatar" size="large" width={40} height={40} round />
          <Flex vertical gap="2px">
            <Skeleton active size="small" width={120} height={14} />
            <Skeleton active size="small" width={180} height={12} />
          </Flex>
        </Flex>
      ) : (
        <Flex gap="12px" align="flex-start">
          <Avatar
            src={client?.picture}
            size={40}
            colorKey={localisedValue({ object: client, key: "name" })?.[0]?.toLowerCase()}
          >
            {localisedValue({ object: client, key: "name" })?.[0]?.toUpperCase()}
          </Avatar>
          <Flex vertical gap="2px">
            <TitleDescription
              title={
                <Text className="bold fs16 fw-medium">
                  {capitalizeFirstLetter(localisedValue({ object: client, key: "name" }))}
                </Text>
              }
              gapSpace={6}
              description={joinBytItems(
                [
                  <Text type="secondary">{`ID: ${client?.id}`}</Text>,
                  <FLagWithText
                    title={localisedValue({ key: "name", object: client?.Country })}
                    countryCode={client.Country?.locCode || configs?.countryCode || "PK"}
                    infoText={
                      <span>
                        {localisedValue({ key: "name", object: client?.City }) ||
                          localisedValue({ key: "name", object: client?.Country })}
                      </span>
                    }
                  />
                ].filter(Boolean),
                <Icon icon="GoDotFill" size=".7em" color="#D6D6D6" />
              )}
            />
          </Flex>
        </Flex>
      )}
    </Flex>
  )
})

export default ChatHeader
